export default __webpack_public_path__ + "static/media/bookmark-alt.38f3ce09.svg";